import MemberDetailPage from './memberDetailPage';
export default MemberDetailPage;